import { useState, useEffect } from "react";
// Removed unused DropdownIcon import
import Logo from "assets/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(null);

  // Convert footer links to match ResponsiveAppBar structure
  const footerNavItems = [
    {
      id: "property-owners",
      title: "Property Owners",
      dropdownItems: [
        { id: "h", label: "Homeowners", link: "/homeowners" },
        { id: "l", label: "Landlords", link: "/landlords" },
        { id: "s", label: "Short Term Rental Hosts", link: "/short-term-rentals" },
      ],
    },
    {
      id: "property-managers",
      title: "Property Managers",
      link: "/property-managers",
      dropdownItems: [
        {
          id: "property-maintenance-property-manager",
          label: "Property Maintenance",
          link: "property-maintenance-property-manager",
        },
        {
          id: "end-to-end-repair-management-property-manager",
          label: "End-to-End Repair Management",
          link: "end-to-end-repair-management-property-manager",
        },
        {
          id: "how-properteasy-works-property-manager",
          label: "How It Works",
          link: "how-properteasy-works-property-manager",
        },
        {
          id: "pricing-property-manager",
          label: "Pricing",
          link: "pricing-property-manager",
        },
        {
          id: "faqs-property-manager",
          label: "FAQs",
          link: "faqs-property-manager",
        },
      ],
    },
    {
      id: "vendors",
      title: "Vendors",
      link: "/vendors",
      dropdownItems: [
        {
          id: "grow-your-business",
          label: "Grow Your Business",
          link: "grow-your-business",
        },
        {
          id: "verified-vendor-onboarding",
          label: "Verified Vendor Onboarding",
          link: "verified-vendor-onboarding",
        },
        {
          id: "payout-stucture-vendor",
          label: "Payout Structure",
          link: "payout-stucture-vendor",
        },
        {
          id: "what-makes-properteasy-different-vendor",
          label: "What Makes Properteasy Different",
          link: "what-makes-properteasy-different-vendor",
        },
        {
          id: "faqs-vendor",
          label: "FAQs",
          link: "faqs-vendor",
        },
      ],
    },
    {
      id: "company",
      title: "Company",
      link: "/",
      dropdownItems: [
        { id: "about-us", label: "About Us", link: "/" },
        { id: "blog", label: "Blog", link: "/blog" },
        { id: "legal", label: "Legal", link: "/legal" },
      ],
    },
  ];

  // Update active section when location changes - same logic as ResponsiveAppBar
  useEffect(() => {
    // Check if any section is currently in view
    const checkActiveSection = () => {
      const sections = [
        "property-maintenance-homeowner",
        "end-to-end-repair-management-homeowner",
        "how-properteasy-works-homeowner",
        "pricing-homeowner",
        "what-makes-properteasy-different-homeowner",
        "faqs-homeowner",
        "stay-updated-homeowner",
        "property-maintenance-landlord",
        "end-to-end-repair-management-landlord",
        "how-properteasy-works-landlord",
        "pricing-landlord",
        "what-makes-properteasy-different-landlord",
        "faqs-landlord",
        "stay-updated-landlord",
        "grow-your-business",
        "verified-vendor-onboarding",
        "payout-stucture-vendor",
        "what-makes-properteasy-different-vendor",
        "faqs-vendor",
        "stay-updated-vendor",
      ];

      let activeSectionId = null;
      let maxVisibleRatio = 0;

      sections.forEach((sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const visibleHeight =
            Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
          const visibleRatio = visibleHeight / rect.height;

          if (visibleRatio > maxVisibleRatio && visibleRatio > 0.3) {
            maxVisibleRatio = visibleRatio;
            activeSectionId = sectionId;
          }
        }
      });

      setActiveSection(activeSectionId);
    };

    // Debounced scroll handler
    let scrollTimeout;
    const debouncedCheckActiveSection = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkActiveSection, 100);
    };

    // Check on mount and scroll
    checkActiveSection();
    window.addEventListener("scroll", debouncedCheckActiveSection);

    return () => {
      window.removeEventListener("scroll", debouncedCheckActiveSection);
      clearTimeout(scrollTimeout);
    };
  }, [location.pathname]);

  // Handle footer link click - same logic as ResponsiveAppBar
  const handleFooterLinkClick = (link, parentItem) => {
    if (!link) return;

    if (link.startsWith("/")) {
      navigate(link);
      return;
    }

     // Check if we're already on the correct page
     if (location.pathname === parentItem.link) {
      // We're on the same page, just scroll to the section
      const element = document.getElementById(link);
      if (element) {
        const elementPosition = element.offsetTop - 80; // 80px offset
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    } else {
      {
        parentItem.link &&
          navigate(parentItem.link, {
            state: { scrollToId: link },
          });
      }
    }
  };

  return (
    <footer className="bg-white ">
      <div
        className={`bg-white relative  py-10 md:py-16 lg:py-24 ${
          location.pathname === "/" ? "md:px-6 px-4" : "md:px-12 px-6"
        }`}
      >
        {" "}
        <div className="hidden md:grid grid-cols-[1.51fr_1fr_1fr_1fr_1fr] gap-6 lg:max-w-[1440px] mx-auto">
          <div className="max-w-[400px]">
            <img src={Logo} alt="Properteasy logo" className="h-[32px] lg:h-[40px]" />
            <p
              style={{ letterSpacing: "0.025em", lineHeight: "24px" }}
              className="text-[14px] lg:text-[14px] text-[#242424] mt-5 max-w-[270px] w-full"
            >
              Connecting property owners with trusted maintenance professionals.
              Making property upkeep simple, reliable, and affordable.
            </p>
            <p
              style={{ letterSpacing: "0.025em", lineHeight: "24px" }}
              className="text-[14px] text-[#242424] mt-4 font-semibold"
            >
              24/7 Email Support:{" "}
              <a
                href="mailto:support@properteasy.com"
                className="font-normal hover:underline"
              >
                support@properteasy.com
              </a>
            </p>
          </div>

          {footerNavItems.map((section) => (
            <div key={section.id} className="">
              <h4
                style={{ letterSpacing: "0.025em" }}
                className="font-semibold mb-4 text-[16px] lg:text-[18px]"
              >
                {section.title}
              </h4>
              <ul className="space-y-4">
                {section.dropdownItems.map((link) => (
                  <li key={link.id}>
                    <h6
                      style={{ letterSpacing: "0.025em" }}
                      className={`text-sm cursor-pointer font-[400] transition-colors ${
                        activeSection === link.link
                          ? "text-[#3CAB5C] font-medium"
                          : "text-[#242424] hover:text-black"
                      }`}
                      onClick={() => handleFooterLinkClick(link.link, section)}
                    >
                      {" "}
                      {link.label}
                    </h6>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        {/* Mobile Layout - Flex Wrap */}
        <div className="block md:hidden lg:max-w-[1440px] mx-auto">
          <div className="mb-8">
            <img src={Logo} alt="Properteasy logo" className="h-[24px]" />
            <p
              style={{ letterSpacing: "0.025em", lineHeight: "22px" }}
              className="text-[14px] text-[#242424] mt-5 max-w-[500px]"
            >
              Connecting property owners with trusted maintenance professionals.
              Making property upkeep simple, reliable, and affordable.
            </p>
            <p
              style={{ letterSpacing: "0.025em", lineHeight: "22px" }}
              className="text-[14px] text-[#242424] mt-4 font-semibold"
            >
              24/7 Email Support:{" "}
              <a
                href="mailto:support@properteasy.com"
                className="font-normal hover:underline"
              >
                support@properteasy.com
              </a>
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {footerNavItems.map((section) => (
              <div key={section.id} className="min-w-[100px] flex-1">
                <h4
                  style={{ letterSpacing: "0.025em" }}
                  className="font-semibold mb-4 text-[16px]"
                >
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.dropdownItems.map((link) => (
                    <li key={link.id}>
                      <h6
                        style={{ letterSpacing: "0.025em" }}
                        className={`text-sm cursor-pointer font-[400] transition-colors ${
                          activeSection === link.link
                            ? "text-[#3CAB5C] font-medium"
                            : "text-[#242424] hover:text-black"
                        }`}
                        onClick={() =>
                          handleFooterLinkClick(link.link, section)
                        }
                      >
                        {" "}
                        {link.label}
                      </h6>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="lg:max-w-[1440px] mx-6 mb-5">
        <h5 className="text-[#242424] ">
          © 2025 Properteasy. All rights reserved.
        </h5>
      </div>
    </footer>
  );
};
export default Footer;
